import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { IDoctors } from "./models";
import { doctorItems } from "./doctor.mock";
import { memo, useCallback, useState } from "react";
import { Doctor } from "./DoctorForm/Doctor";

const translationPath = "page.4uDlist.generationRule.doctor.";

export const DoctorPage = memo(() => {
  const [doctor, setDoctor] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<IDoctors>[] = [
    {
      field: "sector",
      headerName: t(translationPath + "sector") || "Sector",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setDoctor(true);
  };

  const handleRowClick = (params: GridRowParams<IDoctors>) => {
    if (!params.row) return;
    setDoctor(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setDoctor(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {doctor && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Doctor id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!doctor && (
        <Box height={600}>
          <Table<IDoctors>
            showDefaultMacroFilters={false}
            rows={doctorItems}
            columns={columns}
            title={t(translationPath + "doctors")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={t(translationPath + "add_doctor") || "Add Doctor"}
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
